module.exports = __webpack_public_path__ + "static/media/es-pv.4abb6c8e.svg";